var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 9.7915C2.5 9.44633 2.77982 9.1665 3.125 9.1665H16.4583C16.8035 9.1665 17.0833 9.44633 17.0833 9.7915C17.0833 10.1367 16.8035 10.4165 16.4583 10.4165H3.125C2.77982 10.4165 2.5 10.1367 2.5 9.7915Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBlack);
export default __webpack_public_path__ + "static/media/dash-black.6c342b006ba18c6a06dea7640aec70b7.svg";
export { ForwardRef as ReactComponent };